module.exports = __webpack_public_path__ + "fonts/pdf.fde29d48.eot";